import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

// Shared primitives for the Compass product page.

// Honest labelling for product screenshots that contain demo workspaces.
export const DemoCaption = ({ className }) => (
  <p className={cn('mt-3 text-center text-[11px] font-semibold uppercase tracking-widest text-slate-400', className)}>
    Product visuals show illustrative demonstration data
  </p>
);

// Minimal browser-frame treatment — no fake URL, no excess chrome.
export const BrowserFrame = ({ shot, eager = false, label = 'Amden — demonstration workspace', className }) => (
  <figure className={cn('overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lift', className)}>
    <div className="flex items-center gap-2 border-b border-slate-100 bg-slate-50 px-4 py-2.5" aria-hidden="true">
      <span className="h-2.5 w-2.5 rounded-full bg-slate-300" />
      <span className="h-2.5 w-2.5 rounded-full bg-slate-300" />
      <span className="h-2.5 w-2.5 rounded-full bg-slate-300" />
      <span className="ml-3 rounded-md bg-white px-3 py-1 text-[11px] font-semibold text-slate-500 ring-1 ring-slate-200">
        {label}
      </span>
    </div>
    <img
      src={shot.src}
      alt={shot.alt}
      width={shot.width}
      height={shot.height}
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : undefined}
      className="w-full"
    />
  </figure>
);

// Phone-style frame: the slight inset scale masks hard screenshot edges.
export const PhoneFrame = ({ shot, className }) => (
  <figure
    className={cn('overflow-hidden rounded-[2rem] border border-slate-700 bg-navy-900 p-1.5 shadow-lift', className)}
  >
    <img
      src={shot.src}
      alt={shot.alt}
      width={shot.width}
      height={shot.height}
      loading="lazy"
      className="w-full rounded-[1.7rem]"
    />
  </figure>
);

export const CheckList = ({ items, dark = false, testid }) => (
  <ul className={cn('grid gap-x-6 gap-y-2.5 sm:grid-cols-2')} data-testid={testid}>
    {items.map((item) => (
      <li key={item} className={cn('flex items-start gap-2.5 text-sm font-semibold', dark ? 'text-slate-200' : 'text-navy-800')}>
        <Check className={cn('mt-0.5 h-4 w-4 shrink-0', dark ? 'text-gold-500' : 'text-gold-700')} aria-hidden="true" />
        {item}
      </li>
    ))}
  </ul>
);

export const Chip = ({ children, dark = false }) => (
  <span
    className={cn(
      'inline-flex items-center rounded-full px-3 py-1.5 text-xs font-bold',
      dark ? 'border border-white/15 bg-white/5 text-slate-200' : 'border border-slate-200 bg-white text-navy-800'
    )}
  >
    {children}
  </span>
);
